import { useNavigate } from "react-router-dom";
import {
  buildSortedQueryString,
  TQuerystringParams,
} from "../utils/miscellaneous";
import { useTypedDispatch } from "./useTypedDispatch";
import { SET_QUERYSTRING } from "../redux/reducers/querystring";

export function toQuerystringState(
  params: TQuerystringParams
): Record<string, any> {
  const querystringState: Record<string, any> = {};
  (Object.entries(params) as [keyof TQuerystringParams, any][]).forEach(
    ([key, value]) => {
      if (value !== undefined && value !== null) {
        querystringState[key] = value;
      }
    }
  );
  return querystringState;
}
/**
 * useNavigationManager
 * Centralized hook for navigation, querystring, and filter state management.
 */
export function useNavigationManager() {
  // Converts TQuerystringParams to a plain object suitable for buildSortedQueryString

  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  // Write querystring to URL and sync with Redux
  function setQuerystring(newState: TQuerystringParams) {
    const querystringState = toQuerystringState(newState);
    const sortedQs = buildSortedQueryString(querystringState);
    navigate({ search: sortedQs }, { replace: true });
    // Returns a promise that resolves when the thunk is done
    return dispatch(SET_QUERYSTRING(newState));
  }

  // SPA navigation with querystring
  function goTo(path: string, qs?: TQuerystringParams) {
    let url = path;
    if (qs) {
      const querystringState = toQuerystringState(qs);
      const sortedQs = buildSortedQueryString(querystringState);
      url += `?${sortedQs}`;
    }
    navigate(url);
  }

  return {
    setQuerystring,
    goTo,
  };
}
